function getCookie(name) {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
        let split = el.split('=');
        cookie[split[0].trim()] = split.slice(1).join("=");
    })
    return cookie[name];
}

function cookieExists(name) {
    let cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(name + "=") == 0) {
            return true;
        }
    }
    return false;
}

function updateCookie(name, value) {
    let myDate = new Date();
    myDate.setMonth(myDate.getMonth() + 24);
    document.cookie = name + "=" + value + "; expires=" + myDate + "; domain=." + window.location.hostname + "; path=/; SameSite=Lax";
}

function consenter() {
    if (cookieExists("_tracking_consent")) {
        let x = getCookie("_tracking_consent");
        if (x) {
            let decoded_cookie = decodeURIComponent(x);
            let cookie_data_consent = JSON.parse(decoded_cookie);
            let y = getCookie("_cmp_a");
            if (y) {
                decoded_cookie = decodeURIComponent(y);
                let cookie_data = JSON.parse(decoded_cookie);

                if (cookie_data_consent.con.CMP.s == "0") {
                    cookie_data.purposes.s = false;
                }

                if (cookie_data_consent.con.CMP.m == "0") {
                    cookie_data.purposes.m = false;
                }

                if (cookie_data_consent.con.CMP.a == "0") {
                    cookie_data.purposes.a = false;
                }

                if (cookie_data_consent.con.CMP.p == "0") {
                    cookie_data.purposes.p = false;
                }

                let modified_encoded_cookie = encodeURIComponent(JSON.stringify(cookie_data));
                updateCookie("_cmp_a", modified_encoded_cookie);
            }
        }
    }
}

function cookieMeister() {
    let y = getCookie("_cmp_a");
    if (y) {
        let decoded_cookie = decodeURIComponent(y);
        let cookie_data = JSON.parse(decoded_cookie);
        if (cookie_data.purposes.a == false && cookie_data.purposes.t == true && cookie_data.purposes.m == false && cookie_data.purposes.p == false) {
            cookie_data.purposes.s = false;
            cookie_data.purposes.m = true;
            cookie_data.purposes.a = true;
            cookie_data.purposes.p = false;
            let modified_encoded_cookie = encodeURIComponent(JSON.stringify(cookie_data));
            updateCookie("_cmp_a", modified_encoded_cookie);
        }

        if (cookie_data.purposes.a == false || cookie_data.purposes.m == false) {
            cookie_data.purposes.a = true;
            cookie_data.purposes.m = true;
            let modified_encoded_cookie = encodeURIComponent(JSON.stringify(cookie_data));
            updateCookie("_cmp_a", modified_encoded_cookie);
        }
    }
    consenter();
}

document.addEventListener('click', function(event) {
    if (event.target && (event.target.id === 'shopify-pc__banner__btn-manage-prefs' || event.target.parentElement.id === 'shopify-pc__banner__btn-manage-prefs')) {
        document.querySelectorAll('.shopify-pc__prefs__scrollable svg[data-icon-type="checked"]').forEach(function(icon) {
			icon.style.display = 'block';
		});
		document.querySelectorAll('.shopify-pc__prefs__scrollable svg[data-icon-type="unchecked"]').forEach(function(icon) {
			icon.style.display = 'none';
		});
    }
});
document.addEventListener("visitorConsentCollected", (event) => consenter());
document.head.insertAdjacentHTML("beforeend", "<style>.shopify-pc__banner__btn-decline{display:none}</style>")
cookieMeister();
